import React, { useState, useEffect } from 'react';
import {
  Router,
  Switch,
  Route,
} from 'react-router-dom';
import { CookiesProvider } from 'react-cookie';
import { createBrowserHistory } from 'history';
import { ThemeProvider, createGlobalStyle } from 'styled-components/macro';

import { onAuthChange, signInAnon } from './lib/Authentication';
import { reset } from './style/themes/reset';
import { AuthProvider } from './hooks/useAuth';
import appTheme from './style/themes/appTheme';

import Master from './routes/Master';
import Loading from './components/Loading';
import Web from './routes/Web';
import { parseUrlParams } from './lib/utils/utils';

const GlobalStyle = createGlobalStyle`
  ${reset}
`;

const history = createBrowserHistory();

const App: React.FC = () => {
  const params = parseUrlParams<{ cabId: string; }>(window.location.href);
  // 柜子ID
  const [cabId32Str, setCabId32Str] = useState<string>(params.cabId);
  // 判断是否不需要登录
  const isNoNeedLogin = window.location.href.includes('/web-terms-of-use');
  const [loggedIn, setLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    console.log('当前版本：', process.env.REACT_APP_VERSION);
  }, []);

  useEffect(() => {
    // 禁止页面缩放
    const meta = document.createElement('meta');
    meta.name = 'viewport';
    meta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no';
    document.getElementsByTagName('head')[0].appendChild(meta);

    const unSubAuth = onAuthChange((user) => {
      if (!user && !isNoNeedLogin) {
        signInAnon().then((anonUser) => {
          if (anonUser) {
            setLoggedIn(true);
            setLoading(false);
          }
        });
      }
      else {
        setLoggedIn(true);
        setLoading(false);
      }
    });
    return () => { unSubAuth(); };
  }, []);

  return (
    <ThemeProvider theme={appTheme}>
      <GlobalStyle />
      <div className="App">
        {(loading || !loggedIn) ? (
          <Loading loadingType="bars" />
        ) : (
          <CookiesProvider>
            <AuthProvider value={loggedIn}>
              <Router history={history}>
                <Switch>
                  <Route path="/main">
                    <Master cabId32Str={cabId32Str} setCabId32Str={setCabId32Str} />
                  </Route>
                  <Route path="/fetch-code" component={Master} />
                  <Route path="/web" component={Web} />
                </Switch>
              </Router>
            </AuthProvider>
          </CookiesProvider>
        )}
      </div>
    </ThemeProvider>
  );
};

export default App;
